import React from "react"
import Layout from "../components/layout"
import LoginForm from "../components/login-form"
import Container from "../components/container"
import PageTitle from "../components/page-title";

function Login() {

    return (
        <Layout>
            <PageTitle>Log in</PageTitle>
            <Container className="container--mob">
                <LoginForm />
            </Container>
        </Layout>
    )
}

export default Login